enum ExportFormat {
	XLSX = 'XLSX',
	CSV = 'CSV',
}
export default ExportFormat;
